var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 -0.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    transform: "translate(0 0.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6487",
    "data-name": "Rectangle 6487",
    width: 49,
    height: 49,
    fill: "#d7b16d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239617",
    "data-name": "Path 239617",
    d: "M34.794,20H6.053a2.053,2.053,0,0,0,0,4.106H34.794a2.053,2.053,0,0,0,0-4.106Z",
    transform: "translate(4.212 20.788)",
    fill: "#d7b16d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239618",
    "data-name": "Path 239618",
    d: "M6.057,34.786h.185l8.561-.78a4.106,4.106,0,0,0,2.484-1.17L35.763,14.359A3.942,3.942,0,0,0,35.619,8.8L29.994,3.171a4.106,4.106,0,0,0-5.461-.144L6.057,21.5a4.106,4.106,0,0,0-1.17,2.484L4,32.548a2.048,2.048,0,0,0,2.053,2.238ZM27.141,6.045l5.6,5.6-4.106,4-5.5-5.5ZM8.87,24.336,20.428,12.861,25.971,18.4l-11.5,11.5-6.159.575Z",
    transform: "translate(4.207 1.897)",
    fill: "#d7b16d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.79f4e87a41f1ff01719d2d408659aa82.svg";
export { ForwardRef as ReactComponent };